const getUserIP = async () => {
    const ipResponse = await fetch('https://api.ipify.org?format=json');
    if (ipResponse.ok) {
        const data = await ipResponse.json();
        return data.ip;
    }
    throw new Error('Unable to fetch IP address');
};

export const getUserCountry = async () => {
    try {
        //const ip = '142.250.70.196' //US
        //const ip = '103.100.100.100' //AU
        //const ip = '103.18.56.0' //NZ
        //const ip = '41.0.0.0' //South Africa
        //const ip = '142.0.0.0' //Canada
        //const ip = '187.190.0.0' //Brazil
        const ip = await getUserIP();

        // Determine if we're on HTTPS or HTTP
        const isHttps = window.location.protocol === 'https:';
        
        let response;
        let data;
        
        if (isHttps) {
            // Use ipapi.co for HTTPS
            response = await fetch(`https://ipapi.co/${ip}/json/`);
            if (!response.ok) {
                throw new Error('Location service error');
            }
            data = await response.json();
            
            // ipapi.co uses different field names
            return {
                country: data.country_name,
                countryCode: data.country_code,
                lat: parseFloat(data.latitude),
                lon: parseFloat(data.longitude)
            };
        } else {
            // Use ip-api.com for HTTP
            response = await fetch(`http://ip-api.com/json/${ip}`);
            if (!response.ok) {
                throw new Error('Location service error');
            }
            data = await response.json();
            
            return {
                country: data.country,
                countryCode: data.countryCode,
                lat: parseFloat(data.lat),
                lon: parseFloat(data.lon)
            };
        }
    } catch (error) {
        console.error('Error getting user country:', error);
        throw error; // Let DataContext handle the error and find nearest country
    }
};

// Helper function to calculate distance between coordinates
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    // Validate inputs
    if (typeof lat1 !== 'number' || typeof lon1 !== 'number' || 
        typeof lat2 !== 'number' || typeof lon2 !== 'number' ||
        isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) {
      console.error('Invalid coordinates:', { lat1, lon1, lat2, lon2 });
      return Infinity; // Return Infinity so this country won't be selected as nearest
    }

    const R = 6371; // Earth's radius in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
        Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const distance = R * c;
    
    if (isNaN(distance)) {
      console.error('Distance calculation resulted in NaN:', {
        lat1, lon1, lat2, lon2, dLat, dLon, a, c
      });
      return Infinity;
    }
    
    return distance;
};

export async function getLocationFromIP() {
    try {
        const response = await fetch('https://ip-api.com/json/');
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error getting location:', error);
        return null;
    }
}